import { Check, ChevronDown } from "lucide-react";
import { VIDEO_PASSEIO, DIVE_MASTER_LOGO } from "@/config/constants";
import { memo } from "react";

// Vídeo da caravela (do mesmo usado na CaravelaSection)
const CARAVELA_VIDEO = "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/4c7n8bsx_lv_0_20260319210744.mp4";

export const HeroSection = memo(({ timeLeft, onOpenPalpiteModal }) => {
  return (
    <section className="hero-section relative overflow-hidden" data-testid="hero-section">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#002776] via-[#003399] to-[#009C3B]"></div>
      
      <div className="relative z-10">
        
        {/* VÍDEO DA CARAVELA NO TOPO */}
        <div className="relative w-full">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            preload="auto"
            className="w-full h-auto object-cover"
          >
            <source src={CARAVELA_VIDEO} type="video/mp4" />
          </video>
          {/* Logo no canto */}
          <img 
            src={DIVE_MASTER_LOGO} 
            alt="Dive Master" 
            className="absolute top-3 right-3 w-12 h-12 object-contain rounded-full shadow-lg"
            loading="eager"
          />
        </div>
        
        {/* Barra decorativa */}
        <div className="w-full h-2 bg-gradient-to-r from-[#009C3B] via-[#FFDF00] to-[#002776]"></div>
        
        <div className="max-w-2xl mx-auto px-4 pt-6 pb-8">

          {/* TÍTULO PRINCIPAL */}
          <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-white leading-tight mb-3 text-center" data-testid="hero-title">
            Navegue de caravela e mergulhe nas águas mais cristalinas de Porto Belo
          </h1>
          
          {/* SUBTÍTULO */}
          <p className="text-sm md:text-base text-white/90 mb-6 text-center leading-relaxed">
            Não precisa saber nadar. Equipamento completo, roupa de neoprene que faz você flutuar e um guia com você o tempo todo.
          </p>
          
          {/* Vídeo do passeio completo */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-3 mb-6 border border-white/20">
            <div className="flex items-center justify-center gap-2 mb-2">
              <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
              <p className="text-[#FFDF00] text-xs font-bold uppercase tracking-wide">
                Veja como é o passeio
              </p>
            </div>
            <div className="w-full max-w-[220px] mx-auto">
              <div className="relative rounded-xl overflow-hidden shadow-xl border-2 border-[#FFDF00]/30" style={{ aspectRatio: '9/16' }}>
                <video 
                  src={VIDEO_PASSEIO}
                  poster="https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/9lkmc3ho_image.png"
                  controls
                  playsInline
                  preload="none"
                  className="w-full h-full object-cover"
                >
                  Seu navegador não suporta vídeo.
                </video>
              </div>
            </div>
          </div>
          
          {/* ============================================
              SEÇÃO "TOPA O DESAFIO?" - ABAIXO DO VÍDEO
              ============================================ */}
          <div className="bg-gradient-to-br from-[#002776] to-[#001a4d] rounded-2xl p-5 mb-6 border-2 border-[#FFDF00]/30">
            {/* Selo */}
            <div className="text-center mb-4">
              <span className="inline-flex items-center gap-2 bg-[#FFDF00] text-[#002776] px-3 py-1 rounded-full text-xs font-bold">
                ⚽ DESAFIO DO HEXA NO MAR
              </span>
            </div>
            
            {/* Título */}
            <h2 className="text-xl md:text-2xl font-black text-white text-center mb-2">
              TOPA O DESAFIO?
            </h2>
            <p className="text-white/70 text-sm text-center mb-4">
              Faça seu palpite: O Brasil leva o Hexa ou não?
            </p>
            
            {/* Prêmios compactos */}
            <div className="space-y-2 mb-4">
              <div className="bg-[#009C3B]/30 rounded-lg p-3 border border-[#009C3B]/50">
                <p className="text-white text-sm text-center">
                  <span className="text-lg mr-2">🏆</span>
                  Acertou? <strong className="text-[#FFDF00]">100% do valor de volta</strong> + passeio grátis
                </p>
              </div>
              <p className="text-center text-[#FFDF00] font-bold text-sm">OU</p>
              <div className="bg-[#009C3B]/30 rounded-lg p-3 border border-[#009C3B]/50">
                <p className="text-white text-sm text-center">
                  <span className="text-lg mr-2">🎟️</span>
                  <strong className="text-[#FFDF00]">Dobro de ingressos</strong> pra levar amigos/família
                </p>
              </div>
            </div>
            
            {/* Errou */}
            <p className="text-white/60 text-xs text-center italic">
              Errou? Sem problema — você vai fazer um passeio inesquecível do mesmo jeito!
            </p>
          </div>
          
          {/* BLOCO DE PREÇO */}
          <div className="bg-white rounded-2xl p-5 shadow-xl max-w-md mx-auto mb-4">
            {/* Preço */}
            <div className="text-center mb-4">
              <p className="text-gray-400 text-sm line-through">De R$ 147</p>
              <p className="text-[#002776] text-4xl md:text-5xl font-black">R$ 97</p>
              <p className="text-gray-600 text-sm">ou <strong className="text-[#002776]">12x de R$ 10,03</strong> sem juros</p>
              <p className="text-[#009C3B] font-bold text-xs mt-1">Por 1 pessoa • Voucher válido 12 meses</p>
            </div>
            
            {/* CTA PRINCIPAL */}
            <button
              onClick={onOpenPalpiteModal}
              className="w-full bg-gradient-to-r from-[#009C3B] to-[#007830] hover:from-[#007830] hover:to-[#006020] text-white font-black py-4 px-6 rounded-xl shadow-lg text-lg animate-pulse-scale transition-all duration-300"
              data-testid="hero-cta-button"
            >
              GARANTIR MEU PASSEIO — R$97
            </button>
            
            {/* MICROCOPY */}
            <div className="flex flex-wrap items-center justify-center gap-3 mt-3 text-gray-500 text-xs">
              <span className="flex items-center gap-1">
                <Check className="w-3 h-3 text-[#009C3B]" /> Pagamento seguro
              </span>
              <span className="flex items-center gap-1">
                <Check className="w-3 h-3 text-[#009C3B]" /> Garantia 30 dias
              </span>
              <span className="flex items-center gap-1">
                <Check className="w-3 h-3 text-[#009C3B]" /> Voucher 12 meses
              </span>
            </div>
          </div>
          
          {/* Link WhatsApp discreto */}
          <p className="text-center">
            <a 
              href="https://wa.me/5547997920909?text=Ol%C3%A1%2C%20tenho%20d%C3%BAvidas%20sobre%20o%20passeio%20antes%20de%20comprar"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 text-xs hover:text-white/90 underline transition-colors"
            >
              Tem dúvida antes de comprar? Fale no WhatsApp
            </a>
          </p>
          
          {/* Indicador de scroll */}
          <div className="flex justify-center mt-6 animate-bounce">
            <ChevronDown className="w-6 h-6 text-white/50" />
          </div>
          
        </div>
      </div>
    </section>
  );
});

export default HeroSection;
